/* @ngInject */
const settingFormat = (
  utils,
  entities,
  valueHandler,
  settingData
) => {
  const self = {}

  self.fieldsToString = (_fields) => {
    if (valueHandler.isNull(_fields)) {
      return null
    }

    let resTable = ''
    let resExcel = ''
    let res = ''

    for (const fieldName in _fields) {
      if (_fields.hasOwnProperty(fieldName)) {
        const field = _fields[fieldName]

        if (field.output) {
          if (field.output.table) {
            resTable += field.ref + ':' + field.output.table.prefill + ';'
          }

          if (field.output.excel) {
            resExcel += field.ref + ':' + field.output.excel.prefill + ';'
          }
        }
      }
    }

    res = 'table-' + resTable + '|excel-' + resExcel
    return res
  }

  self.stringToFields = (_dataString) => {
    if (valueHandler.isNull(_dataString) || !valueHandler.isString(_dataString)) {
      return null
    }

    const fields = {
      table: {},
      excel: {},
    }

    const splitedData = _dataString.split('|')
    let tableString
    let excelString

    for (let index = 0; index < splitedData.length; index++) {
      const string = splitedData[index]

      if (string.match('table')) {
        tableString = splitedData[index]
      }
      if (string.match('excel')) {
        excelString = splitedData[index]
      }
    }

    let tableFields
    if (valueHandler.isString(tableString) && tableString !== '') {
      tableFields = tableString.split('-')[1]
    }
    let excelFields
    if (valueHandler.isString(excelString) && excelString !== '') {
      excelFields = excelString.split('-')[1]
    }

    let tableKeysValues = []
    if (valueHandler.isString(tableFields) && tableFields !== '') {
      tableKeysValues = tableFields.split(';')
    }
    let excelKeysValues = []
    if (valueHandler.isString(excelFields) && excelFields !== '') {
      excelKeysValues = excelFields.split(';')
    }

    for (let index = 0; index < tableKeysValues.length || index < excelKeysValues.length; index++) {
      let tableElement = null
      let excelElement = null
      if (index < tableKeysValues.length) {
        tableElement = tableKeysValues[index]
      }
      if (index < excelKeysValues.length) {
        excelElement = excelKeysValues[index]
      }

      if (valueHandler.isString(tableElement)) {
        const splitedElement = tableElement.split(':')
        const key = splitedElement[0]
        const value = splitedElement[1]
        if (valueHandler.isString(key) && valueHandler.isNotNull(value)) {
          fields.table[key] = value
        }
      }
      if (valueHandler.isString(excelElement)) {
        const splitedElement = excelElement.split(':')
        const key = splitedElement[0]
        const value = splitedElement[1]
        if (valueHandler.isString(key) && valueHandler.isNotNull(value)) {
          fields.excel[key] = value
        }
      }
    }

    return fields
  }

  self.updateGeneralWithDatabase = (_settings) => {
    if (_settings.backButton === null) {
      return
    }
    const checkboxs = settingData.general.checkboxs
    const sliders = settingData.general.sliders

    checkboxs['backButton'].model = !!_settings.backButton
    checkboxs['calendar'].model = !!_settings.calendar
    checkboxs['scrollTop'].model = !!_settings.scrollTop
    checkboxs['largeMode'].model = !!_settings.largeMode
    checkboxs['advancedSearch'].model = !!_settings.advancedSearch

    sliders['displayedItemNumber'].model = parseInt(_settings.displayedItemNumber)
    sliders['autocompleteTimer'].model = _settings.autocompleteTimer
    sliders['toastTimer'].model = _settings.toastTimer
  }

  self.updateLocalWithDatabase = (_settings) => {
    for (const entityName in _settings) {
      if (_settings.hasOwnProperty(entityName)) {
        const entityData = _settings[entityName]
        if (entityName !== 'id' && entityName !== 'userId') {
          const fieldsData = self.stringToFields(entityData)
          let entity
          if (valueHandler.isObject(entities[entityName])) {
            entity = entities[entityName]
            if (valueHandler.isObject(entity.metadata) && valueHandler.isObject(fieldsData)) {
              self.applyData(fieldsData, entity.metadata.fields)
            }
          }
        }
      }
    }
  }

  self.applyData = (_data, _fields) => {
    for (const itemName in _data.table) {
      if (_data.table.hasOwnProperty(itemName)) {
        const tableElement = _data.table[itemName]
        if (valueHandler.isObject(_fields[itemName]) && valueHandler.isObject(_fields[itemName].output) && _fields[itemName].output) {
          const output = _fields[itemName].output
          if (output.table) {
            output.table.prefill = tableElement === 'true'
            output.table.display = tableElement === 'true'
          }
        }
      }

      if (_data.excel.hasOwnProperty(itemName)) {
        const excelElement = _data.excel[itemName]
        if (valueHandler.isObject(_fields[itemName]) && valueHandler.isObject(_fields[itemName].output) && _fields[itemName].output) {
          const output = _fields[itemName].output
          if (output.excel) {
            output.excel.prefill = excelElement === 'true'
            output.excel.display = excelElement === 'true'
          }
        }
      }
    }
  }

  return self
}
export default settingFormat



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/services/format.service.js